export type LeadProgramResolutionMode = 'exact' | 'inferred' | 'unknown';

export interface LeadProgramResolutionPresentation {
  badgeLabel: string;
  description: string;
  evidenceLabel?: string;
}

export function getLeadProgramResolutionPresentation(
  mode: string | undefined,
  sourceCode?: string | null
): LeadProgramResolutionPresentation {
  if (mode === 'exact') {
    return {
      badgeLabel: 'Stored on lead',
      description: 'This program was stored on the lead when CRS processed it.',
    };
  }

  if (mode === 'inferred') {
    return {
      badgeLabel: 'Inferred from current mapping',
      description:
        'This lead did not store a program. CRS inferred this program from the lead provider service and the retailer current brand/program mapping.',
      evidenceLabel: sourceCode?.trim()
        ? `Provider service used: ${sourceCode.trim()}`
        : 'Provider service was not stored on the lead.',
    };
  }

  return {
    badgeLabel: 'Unknown',
    description: 'CRS could not determine a program from the stored lead data or the current retailer/program mapping.',
    evidenceLabel: sourceCode?.trim() ? `Stored provider service: ${sourceCode.trim()}` : undefined,
  };
}
